import styled from "@emotion/styled"
import { Link } from "react-router-dom"

const Button = styled(Link)`
    color: #fff;
    border: 1px solid #fff;
    display: inline-block;
    margin: 2em auto;
    text-transform: uppercase;
    padding: 12px 30px;
    border-radius: 100px;
    font-weight: 400;
    letter-spacing: .5px;
    font-size: 15px;
`

export const SubmitButton = styled("button")`
    background: ${props => props.theme.colors.primary};
    color: #fff;
    border: 1px solid #fff;
    display: inline-block;
    margin: .5rem auto;
    text-transform: uppercase;
    padding: 14px 35px;
    border-radius: 100px;
    font-weight: 400;
    font-size: 15px;
    letter-spacing: .5px;
`

export default Button
